import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ShiftRepository from "../../repositories/ShiftRepository";
import ShiftEntity from "../../entities/ShiftEntity";

interface _Props {
    shiftRepository: ShiftRepository;
}

@injectable()
export default class GetShiftByIdUseCase {
    private shiftRepository: ShiftRepository;
    
    constructor(props: _Props) {
        this.shiftRepository = props.shiftRepository;
    }
    
    public call = async (id: string) : Promise<Either<ErrorEntity, ShiftEntity>> => {
        return this.shiftRepository.getShiftById(id);
    }
}

export const GetShiftByIdUseCaseName = "GetShiftByIdUseCase";